class NotAuthorizedException extends Error {
    constructor(message) {
        super(message);
        this.name = 'NotAuthorizedException';
    }
}

class InvalidCredentialsException extends Error {
    constructor(message) {
        super(message);
        this.name = 'InvalidCredentialsException';
    }
}

class PasswordAttemptsExceededException extends Error {
    constructor(message) {
        super(message);
        this.name = 'PasswordAttemptsExceededException';
    }
}

class RequiresTwoFactorAuthenticationCode extends Error {
    constructor(message) {
        super(message);
        this.name = 'RequiresTwoFactorAuthenticationCode';
    }
}

class InvalidTwoFactorAuthenticationCode extends Error {
    constructor(message) {
        super(message);
        this.name = 'InvalidTwoFactorAuthenticationCode';
    }
}

class RequiresPasswordReset extends Error {
    constructor(message, token) {
        super(message);
        this.name = 'RequiresPasswordReset';
        this.token = token;
    }
}

export {
    NotAuthorizedException,
    InvalidCredentialsException,
    PasswordAttemptsExceededException,
    RequiresTwoFactorAuthenticationCode,
    InvalidTwoFactorAuthenticationCode,
    RequiresPasswordReset
};
